import axios from "../../privateApi";

export const hideSbcSet = (setId: number, isHidden: boolean) =>
  axios.post("/hide-sbc-set", { setId, isHidden });
